var exports = {
  "k": "container__z80Lwt",
};

module.exports = exports;
